import _ from "lodash";
import { Contact } from "./Contact";
import { Intervention } from "./Intervention";

export namespace Audit {
    export class Evenement {
        id?: number;
        titre?: string;
        locationStr?: string;
        element_id?: number;
        location_id?: number;
        location_type?: string;
        type_id?: number;
        audit_id?: number;
        private _client?: Contact;
        photos: Array<Object> = [];
        hash?: string;

        constructor(data: any) {
            let self = this;
            _.assign(this, _.omit(data, "client"));
            if (data.client) {
                self._client = new Contact(data.client);
            }
        }
        get client(): Contact | undefined {
            return this._client;
        }

        //
        get sharedPhotos(): Array<Object> {
            return _.filter(this.photos, function (photo) {
                // @ts-ignore
                return photo.shared == true;
            });
        }

        get statusHtml(): string {
            let res =
                "<table style='background-color: gray; color: white; border-radius: 25px; width: 100%; padding: 10px; margin-bottom: 1rem'>";
            res +=
                "<tr><td style='font-weight: bold; padding-left: 2rem; padding-top: 1rem; font-size: 2rem;'>" +
                (this.client ? this.client.nom : "") +
                "</td><td></td>";
            res += "</tr>";
            res +=
                "<tr><td style='padding-left: 5rem; padding-top: 1rem; padding-bottom: 1rem;'>" +
                this.locationStr +
                "</td><td></td>" +
                "</tr>";
            res +=
                "<tr><td style='padding-left: 5rem; padding-bottom: 1rem; font-size: 1.5rem; font-style: italic;'>" +
                "&#10003;&nbsp;" +
                this.titre +
                "</td><td style='padding-left: 1rem; padding-bottom: 1rem'>";
            if (this.sharedPhotos.length > 0) {
                res +=
                    '<a style="position: relative; text-decoration: none;" href="';
                res +=
                    window.location.origin +
                    "/#/signalement/" +
                    this.hash +
                    "/photos";
                res += '">';
                res +=
                    "<img alt='photos' src='" +
                    window.location.origin +
                    "/img/interface/mailing/camera-sharp-solid.png' style='max-height: 3rem;' height='35'>&nbsp;" +
                    "<span style='margin: 1rem; padding: 0.2rem 0.5rem; background: #5d9cec; color: white; font-weight: bold;'>voir les photos</span>";
                res += "</a>";
            }
            res += "</td></tr>";
            res += "</table>";
            return res;
        }
    }
}
